import React from "react";
import { Box, Typography, Button } from "@mui/material";

export default function ChineseLanguage() {
    return (
        <Box sx={{ padding: "2rem", background: "#f9fafb", maxWidth: "900px", margin: "auto" }}>
            <Typography variant="h4" sx={{ fontWeight: "700", color: "#09122C", mb: 2 }}>
                🇨🇳 Chinese (Mandarin) & English Programs – China-Africa Global Exchange
            </Typography>

            <Typography variant="body1" sx={{ mb: 2, color: "#374151", lineHeight: 1.7 }}>
                Our Mandarin and English courses support entrepreneurs, professionals, and students engaging with China’s growing global influence. Whether you’re in trade, tech, or cultural diplomacy, we’ll help you master the language of business and exchange.
            </Typography>

            <ul style={{ lineHeight: "1.8", color: "#374151" }}>
                <li>Mandarin basics + advanced fluency track</li>
                <li>African trade prep for China partnerships</li>
                <li>Business Chinese for exporters & logistics pros</li>
                <li>English TOEFL prep for Chinese learners going abroad</li>
            </ul>

            <Button
                variant="contained"
                href="/country/china"
                sx={{
                    mt: 3,
                    backgroundColor: "#065f46",
                    "&:hover": { backgroundColor: "#09122C" }
                }}
            >
                View China Language Programs
            </Button>
        </Box>
    );
}
